export const YandexIcon = () => (
  <svg width="12" height="18" viewBox="0 0 17 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7539 26.1125H16.9625V0.375H10.8369C4.67624 0.375 1.44482 3.73889 1.44482 8.70816C1.44482 12.998 3.53978 15.4166 7.25076 18.0438L9.50558 19.6312L6.61135 17.042L0.876587 26.1125H5.43931L11.5656 16.3618L9.435 14.8498C6.86048 12.998 5.59976 11.5618 5.59976 8.44371C5.59976 5.70395 7.41122 3.85214 10.855 3.85214H12.737V26.1125H12.7551H12.7539Z"
      fill="#FC3F1D"
    />
  </svg>
)
